import * as React from 'react';
import { FormGroup, Input } from 'reactstrap';
import { StringFilterEditProps } from '../providers/SingleValue';
import FiltersListAddButton from './FiltersListAddButton';
import FilterEditRequiredValidation from './FilterEditRequiredValidation';

interface SingleTextFilterEditState {
	currentValue: string;
	displayValidationError: boolean;
}

/**
 * Configures a single text value in a filter
 */
class SingleTextFilterEdit extends React.PureComponent<StringFilterEditProps, SingleTextFilterEditState> {
	constructor(props) {
		super(props);

		this.state = {
			currentValue: props.value || '',
			displayValidationError: false,
		};
	}

	/**
	 * Bubbles up state to the parent component.
	 *
	 * @private
	 * @memberof SingleTextFieldEdit
	 */
	private handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		this.setState({ currentValue: e.currentTarget.value });
	};

	private handleSearch = () => {
		const trimmedValue = this.state.currentValue.trim();
		const validationError = !this.props.filter.nullable && !trimmedValue;

		this.setState({
			displayValidationError: validationError,
		});

		if (!validationError) {
			this.props.onChange(this.state.currentValue, false);
		}
	};

	/**
	 * Allow users to hit enter to add new values.
	 *
	 * @private
	 * @memberof MultipleTextFieldEdit
	 */
	private handleOnKeyDown = (e: React.KeyboardEvent) => {
		if (e.which === 13) {
			e.preventDefault();
			this.handleSearch();
		}
	};

	public render() {
		return (
			<FormGroup>
				<Input
					id="fieldValue"
					type="text"
					autoFocus
					placeholder={this.props.filter.nullable ? '<Empty>' : 'Enter a value to filter by'}
					value={this.state.currentValue}
					onChange={this.handleOnChange}
					onKeyDown={this.handleOnKeyDown}
				/>
				<div className="filters-popover__actions">
					<FiltersListAddButton onClick={this.handleSearch} />
				</div>
				{this.state.displayValidationError ? <FilterEditRequiredValidation /> : null}
			</FormGroup>
		);
	}
}

export default SingleTextFilterEdit;
